import React, { useEffect, useState } from "react";
import "../../Styles/Plans.css";
import Loader from "../../Components/Loader";

function Plans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchActivePlans = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("No authentication token found");
        return;
      }
      const response = await fetch(
        "https://api.uniums.com/api/User/get-active-subscription-plans",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await response.json();

      if (data.success) {
        setPlans(data.data);
      } else {
        console.log("No active subscription plans found");
      }
    } catch (error) {
      console.error("Error fetching active subscription plans:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActivePlans();
  }, []);

  if (loading) {
    return (
      <>
        <Loader />
        <div>Loading...</div>
      </>
    );
  }

  return (
    <div className="plans-container">
      <h1 className="plans-heading">Activate Plans</h1>

      <div className="admin-table-container">
        <table className="plans-table">
          <thead>
            <tr>
              <th>SL No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Organization Name</th>
              <th>Contact</th>
              <th>Users Limit</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Days</th>
            </tr>
          </thead>
          <tbody>
            {plans.map((plan, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{plan.adminId.name}</td>
                <td>{plan.adminId.email}</td>
                <td>{plan.adminId.organizationName}</td>
                <td>{plan.adminId.organizationContact}</td>
                <td>{plan.approvedUsers}</td>
                <td>{new Date(plan.fromDate).toLocaleDateString()}</td>
                <td>{new Date(plan.toDate).toLocaleDateString()}</td>
                <td className="active_days">{plan.days}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Plans;
